<template>
  <div class="enrolling-statistics-admission-index" v-loading="loading">
    <div class="header">
      <div class="search-item">
        <span>选择批次</span>
        <el-select v-model="batchId" filterable>
          <el-option v-for="item in batchList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <el-input v-model="searchText" placeholder="关键字搜索" prefix-icon="el-icon-search"></el-input>
      </div>
    </div>
    <div class="main">
      <div v-if="statisticsFilterList && statisticsFilterList.length" class="statistics-main">
        <component v-for="item in statisticsFilterList" :key="item.type"
                   :is="item.component" :name="item.name" :type="item.type"
                   :batchId="batchId" :siteList="siteList"></component>
      </div>
      <Hint v-else type="empty">
        <div>无匹配的统计</div>
      </Hint>
    </div>
  </div>
</template>

<script>
import Hint from '../../../../../../elements/Hint'
import Other from './other/index'
export default {
  name: 'EnrollingStatisticsAdmission',
  components: {
    Hint,
    Other
  },
  data () {
    return {
      loading: false,
      batchList: [],
      siteList: [],
      batchId: '',
      searchText: null,
      statisticsList: [
        {
          name: '录取学生性别分析',
          type: 'gender',
          component: Other
        },
        {
          name: '录取学生年龄分析',
          type: 'age',
          component: Other
        },
        {
          name: '录取学生民族分析',
          type: 'folk',
          component: Other
        },
        {
          name: '录取学生政治面貌分析',
          type: 'polity',
          component: Other
        },
        {
          name: '录取学生单位性质分析',
          type: 'unitType',
          component: Other
        },
        {
          name: '录取学生职级分析',
          type: 'jobLevel',
          component: Other
        },
        {
          name: '录取学生所属行业分析',
          type: 'industry',
          component: Other
        },
        {
          name: '录取学生职称分析',
          type: 'jobTitle',
          component: Other
        },
        {
          name: '录取学生学历分析',
          type: 'degree',
          component: Other
        },
        {
          name: '录取学生笔试免考类型分析',
          type: 'writeExempt',
          component: Other
        }
      ]
    }
  },
  computed: {
    statisticsFilterList () {
      if (this.searchText) {
        return this.statisticsList.filter(item => item.name.includes(this.searchText))
      }
      return this.statisticsList
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/statistics/loadData',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.batchList = response.data['batchList'] || []
              this.siteList = response.data['siteList'] || []
              this.batchId = response.data['batchId'] || ''
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.enrolling-statistics-admission-index {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  & > .header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: right;
    border-bottom: solid 1px #f2f2f2;
    .search-item {
      padding-right: 20px;
      & > span {
        padding-right: 10px;
      }
    }
  }
  & > .main {
    height: calc(100% - 60px);
    .statistics-main {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      overflow-y: auto;
    }
  }
}
</style>
